/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Typography } from '@material-ui/core';
import { CURRENT_PLAN, LUMINATE_BASIC } from 'constants/constant';
import dashboardStyles from './banner.style';

function Banner() {
	const classes = dashboardStyles();

	return (
		<Box className={classes.bannerContainer}>
			<Box className={classes.textContainer}>
				<Typography className={classes.regularText}>{CURRENT_PLAN}</Typography>
				<Typography className={classes.boldText}>{LUMINATE_BASIC}</Typography>
			</Box>
		</Box>
	);
}

export default Banner;
